export const ComingSoonImage = ({ itemName, testId }) => (
  <div className="coming-soon-image" data-testid={testId} role="img" aria-label={`Foto pendiente de ${itemName}`}>
    <span>Foto próximamente</span>
    <p>La foto llegará pronto, pero te aseguro que está rico.</p>
  </div>
);